import { ApiService } from "../api.service";
import {
  CustomerOrderRequest,
  CustomerOrderRequestNonAdmin,
  CustomerOrderByIDRequest,
  CustomerOrderSingle,
} from "@/models/entities/customerOrder/customerOrderRequest.interface";

const CONTROLLER = "/customerorder";

class CustomerOrderService extends ApiService {
  getOrders(
    fromDate: string,
    toDate: string,
    orderID: number,
    onlyComplete: boolean,
    onlyNotSent: boolean
  ) {
    return this.getAll<CustomerOrderRequest[]>(
      `${CONTROLLER}/customerorders?fromDate=${encodeURIComponent(
        fromDate
      )}&toDate=${encodeURIComponent(
        toDate
      )}&orderID=${orderID}&onlyComplete=${onlyComplete}&onlyNotSent=${onlyNotSent}`
    );
  }

  getOrdersByCustomer(
    userName: string,
    fromDate: string,
    toDate: string,
    orderID: number,
    onlyComplete: boolean,
    onlyNotSent: boolean
  ) {
    return this.getAll<CustomerOrderRequestNonAdmin[]>(
      `${CONTROLLER}/customerordersnonadmin?userName=${userName}&fromDate=${encodeURIComponent(
        fromDate
      )}&toDate=${encodeURIComponent(
        toDate
      )}&orderID=${orderID}&onlyComplete=${onlyComplete}&onlyNotSent=${onlyNotSent}`
    );
  }

  getOrderByID(orderID: number) {
    return this.getAll<CustomerOrderByIDRequest[]>(
      `${CONTROLLER}/customerorderbyid?orderID=${orderID}`
    );
  }

  getOrderKitsByID(orderID: number) {
    return this.getAll<number>(
      `${CONTROLLER}/getorderkitsbyid?orderID=${orderID}`
    );
  }

  sendEmail(orderID: number, customerId: string) {
    return this.getAll<boolean>(
      `${CONTROLLER}/sendmail?orderID=${orderID}&customerId=${customerId}`
    );
  }

  exportCustomerOrder(
    orderID: number,
    customerId: string,
    orderDate: string,
    ragioneSociale: string
  ) {
    return this.getAll<{ isSuccess: boolean; result: string }>(
      `${CONTROLLER}/exportcustomerorderbyid?orderID=${orderID}&orderDate=${encodeURIComponent(
        orderDate
      )}&costumerCode=${customerId}&RagioneSociale=${encodeURIComponent(
        ragioneSociale
      )}`
    );
  }

  checkCustomerOrderAccess(orderID: number, idCustomer: string) {
    return this.getAll<boolean>(
      `${CONTROLLER}/CheckCustomerOrderAccess?orderID=${orderID}&idCustomer=${idCustomer}`
    );
  }

  checkOrderSingle(orderID: number) {
    return this.getAll<CustomerOrderSingle>(
      `${CONTROLLER}/OrderInfosByID?orderID=${orderID}`
    );
  }
}

export const customerOrderService = new CustomerOrderService();
